import { computed, getCurrentInstance } from '@vue/composition-api';

import { pictures, authorList } from '@/utils/formatters/formattedProduct';
import { productImage } from '@/utils/constants/catalogConstants';
import { checkMobile } from '@/utils/deviceCheck';

import { MIN_QUANTITY_THINGS, MAX_COUNT_BASKET } from '@/utils/constants/globalConst';

const useProductItem = (props) => {
  const { emit } = getCurrentInstance();
  const isMobile = checkMobile();

  const productLink = computed(() => (props.link ? props.link : ''));

  const isLast = computed(() => props.quantityAvailable === 1);

  const isLittle = computed(() => !props.isPreOrder && props.quantityAvailable <= MIN_QUANTITY_THINGS && !isLast.value);

  const cntInfoText = computed(() => {
    let text = '';
    if (!props.isAvailable && !props.isPreOrder) {
      text = 'Нет в наличии';
    } else if (isLast.value) {
      text = 'Последний экземпляр';
    } else if (isLittle.value) {
      text = `Осталось ${!isMobile ? 'в наличии:' : ''} ${props.quantityAvailable} шт.`;
    }
    return text;
  });

  const buyOnlyPrePaidInfoText = computed(() => (props.isBuyOnlyPrePaid ? 'Товар по предоплате на сайте' : ''));

  const maxCount = computed(() => (props.quantityAvailable >= MAX_COUNT_BASKET ? MAX_COUNT_BASKET : props.quantityAvailable));

  const showCounter = computed(() => !props.isGift && props.isAvailable && !isLast.value && props.isBasket);

  const productPicture = computed(() => pictures(props.picture, {
    sizePicHeight: 196,
    sizePicWidth: 88,
  }));

  const authorListFormatted = computed(() => authorList(props.authorList));

  const handlerSpliceItem = () => {
    emit(props.isBasket ? 'spliceItem' : 'spliceWishItem', { productId: props.productId });
  };

  const handlerRestoreItem = () => {
    emit(props.isBasket ? 'restoreItem' : 'restoreWishItem', { productId: props.productId, quantity: props.quantityInBasket });
  };

  const handlerChangeCount = (value) => {
    if (value < 1) {
      emit('removeItem', { productId: props.productId });
    } else {
      emit('updateQuantityItem', { productId: props.productId, quantity: value });
    }
  };

  const handlerMoveToWishList = () => {
    emit('moveToWishList', { productId: props.productId });
  };

  const handlerRemoveItem = () => {
    emit(props.isBasket ? 'removeItem' : 'removeWishItem', { productId: props.productId });
  };

  const handlerClickAuth = () => {
    emit('openAuthModal');
  };

  const handlerClickNotAvailable = () => {
    emit('clickNotAvailable', { productId: props.productId });
  };

  const handlerAddToBasketItem = () => {
    emit('addToBasketItem', { productId: props.productId });
  };

  const handlerChangeTab = () => {
    emit('changeTab');
  };

  const handlerClickChangeGift = () => {
    emit('clickChangeGift');
  };

  return {
    productImageFallback: productImage,
    productLink,
    isLast,
    isLittle,
    cntInfoText,
    buyOnlyPrePaidInfoText,
    maxCount,
    showCounter,
    productPicture,
    authorListFormatted,
    handlerSpliceItem,
    handlerRestoreItem,
    handlerChangeCount,
    handlerMoveToWishList,
    handlerRemoveItem,
    handlerClickAuth,
    handlerClickNotAvailable,
    handlerAddToBasketItem,
    handlerChangeTab,
    handlerClickChangeGift,
  };
};

export default useProductItem;
